import RawEndpoint from '@/app/base/endpoints/RawEndpoint';
import { JsonRequestPayload } from '@/app/base/endpoints/types';

export interface ValidatedVatNumberResponse {
    error?: {
        status: number;
        message: string;
        source?: 'vies';
    };
    data?: ValidatedVatNumberResponseData;
}

export interface ValidatedVatNumberResponseData {
    company: string;
    companyType: string;
    address: {
        raw: string;
        display: string;
        street: string;
        city: string;
        postalCode: string;
    };
}

export default class ValidateVatNumberEndpoint extends RawEndpoint {
    path: string = 'common/vat-number';

    async validate(vatNumber: string): Promise<ValidatedVatNumberResponseAttributes> {
        const payload: JsonRequestPayload = {
            method: 'POST',
            path: '-actions/validate',
            data: {
                data: {
                    type: 'vat-number-validation',
                    attributes: {
                        vatNumber,
                    },
                },
            },
        };

        const response = await this.requestRaw(payload);
        const { data, errors } = await response.json();
        console.log('ValidateVatNumberEndpoint', data, errors);

        if (errors && errors.length > 0) {
            return {
                error: {
                    status: errors[0].status,
                    message: errors[0].detail,
                    source: errors[0].source,
                },
            };
        }

        return {
            data: data.attributes,
        };
    }
}
